<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderApiTokens } from '../../model/api-tokens/header-api-tokens.hook'

defineOptions({
  name: 'HeaderApiTokens',
})

const {
  config,
} = useHeaderApiTokens()
</script>

<template>
  <div class="box-api-tokens-header">
    <NavigationBreadcrumbs :config="config" />
  </div>
</template>

<style scoped lang="scss" src="./HeaderApiTokens.scss" />
